import React, { Component } from 'react';
import moment from 'moment-timezone';
import { DateRangePicker, DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './ReactDateRangeWrapper.css'; //overridden styles
import { Dialog, Button } from '@material-ui/core';
import { DateRanges, CustomRangeObject } from './DateRanges';
import { AppTheme, AppStyles } from '../../../styles/AppTheme';
import { StyleSheet, css } from 'aphrodite';
import { isSameDay } from 'date-fns/esm';

/*
  Usage:

  <ReactDateRangeWrapper key='dateTimeRangePicker'
    onDateRangeChange={this.onDateRangeChange}
    // onDateRangeChange({startDate, endDate, id}) { }
    initialRange={{
      id: 'Today', // check below for ids
      // startDate: new Date(), // required when id === 'Custom'
      // endDate: new Date(), // required when id === 'Custom'
    }}
  />

  Possible ids 'Custom', 'Today', 'Yesterday', 'This week', 'This month',
  'Past 7 days', 'Past 30 days', 'Past 1 year', 'Past 5 years',

  startDate and endDate are mandatory when id === 'Custom'

  id --> corresponds to date range defined in ./DateRanges.js file
  More default date ranges can be added in ./DateRanges.js file

  check DateRangePicker corresponding element's classes in
  dev tools and override them in ./ReactDateRangeWrapper.css
  Also check styles of DateRangePicker in react-date-range/dist/theme/default.css

  All dates are local dates from Date object. If required
  use timezone offsets to convert into desired timezone dates in your code
*/


export class ReactDateRangeWrapper extends Component {
  constructor(props) {
    super(props)
    const dIRange = DateRanges.find(range => range.id === props.initialRange.id) || DateRanges[0]
    if(props.initialRange.id === 'Custom') {
      CustomRangeObject.startDate = props.initialRange.startDate
      CustomRangeObject.endDate = props.initialRange.endDate
    }
    const {startDate, endDate, id} = dIRange.range()
    this.state = {
      isOpen: false,

      startDate,
      endDate,
      displayRangeId: id,

      range: {
        startDate,
        endDate,
        key: 'r1' // range key, we use single date range.
      },
      selectedDefinedRangeId: id,
    }
  }
  openDateRangePicker = () => {
    this.setState({
      isOpen: true
    });
  }
  closeDateRangePicker = () => {
    this.setState({
      isOpen: false,
      range: {
        ...this.state.range,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
      },
      selectedDefinedRangeId: this.state.displayRangeId
    });
  }
  applyDateRangePicker = () => {
    const {startDate, endDate} = this.state.range
    const id = this.state.selectedDefinedRangeId
    this.setState({
      isOpen: false,
      startDate,
      endDate,
      displayRangeId: id,
    });
    if(this.props.onDateRangeChange) {
      this.props.onDateRangeChange({
        startDate,
        endDate,
        id: id
      })
    }
  }
  getDefinedRange = (range) => {
    for(let i = 0; i < DateRanges.length; i++) {
      if(DateRanges[i].id !== 'Custom') {
        const definedRange = DateRanges[i].range();
        if(
          isSameDay(range.startDate, definedRange.startDate) &&
          isSameDay(range.endDate, definedRange.endDate)
        ) {
          CustomRangeObject.startDate = range.startDate
          CustomRangeObject.endDate = range.endDate
          const d = DateRanges[i].range()
          range.startDate = d.startDate
          range.endDate = d.endDate
          return d
        }
      }
    }

    CustomRangeObject.startDate = moment(range.startDate).startOf('day')
    CustomRangeObject.endDate = moment(range.endDate).endOf('day')
    range.startDate = moment(range.startDate).startOf('day')
    range.endDate = moment(range.endDate).endOf('day')
    return CustomRangeObject
  }
  onChange = (range) => {
    // console.log(range)
    const {id} = this.getDefinedRange(range.r1)
    this.setState({
      range: {
        ...range.r1,
      },
      selectedDefinedRangeId: id
    })
  }
  render() {
    const {startDate, endDate, displayRangeId} = this.state
    const displayFormat = this.props.dateDisplayFormat || 'Do MMM YYYY'
    let displayText = displayRangeId
    if(!displayText || (displayText === 'Custom')) {
      const start = moment(startDate).format(displayFormat)
      const end = moment(endDate).format(displayFormat)
      displayText = `${start} - ${end}`
    }
    const modalTitle =  'Date Range Picker'
    return (
      <div>

        <div className={css(Styles.displayField)} onClick={this.openDateRangePicker}>
          {displayText}
          <i className='material-icons'>arrow_drop_down</i>
        </div>

        <Dialog
          open={this.state.isOpen}
          aria-labelledby={modalTitle}
          fullScreen={window.innerWidth && window.innerWidth < 480 ? true : false}
          maxWidth='md'
        >

          <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
            <div className={css(Styles.modalTitle)}>{modalTitle}</div>
            <button className={css(Styles.modalCloseButton)} onClick={this.closeDateRangePicker} disabled={this.state.inProcess}>
              <i className='material-icons'>close</i>
            </button>
          </div>

          <div className={css(Styles.modalContent)}>
            <div>
              <DateRangePicker
                ranges={[this.state.range]}
                onChange={this.onChange}
                staticRanges={DateRanges}
                showPreview={true}
                inputRanges={[]}
                rangeColors={this.props.rangeColors || [AppTheme.primaryColor]}
                dateDisplayFormat={displayFormat}
              />
            </div>
            <div className={css(Styles.applyContainer)}>
              <Button
                key = {'applyButton'}
                className = {css(Styles.button)}
                variant='contained' color='primary' onClick={this.applyDateRangePicker}>
                apply
              </Button>
            </div>
          </div>

        </Dialog>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  displayField: {
    backgroundColor: AppTheme.secondaryColor,
    color: 'white',
    padding: 6,
    paddingLeft: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    //minWidth: 100,
    cursor: 'pointer',
    borderRadius: 4
  },
  modalHeader: {
    backgroundColor: 'whitesmoke',
    padding: 10,
    paddingLeft: 20
  },
  modalTitle: {
    color: 'black',
    fontSize: 20,
  },
  modalContent: {
    // paddingLeft: 10,
    // paddingRight: 10
  },
  modalCloseButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    color: 'black'
  },
  modalCloseIcon: {
    width: 28,
    height: 28
  },
  button: {
    boxShadow: 'none',
    marginLeft : 10,
    backgroundColor: AppTheme.secondaryColor,
  },
  applyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 10
  }
})



// WEBPACK FOOTER //
// ./src/common/components/DateRangeComponent/ReactDateRangeWrapper.js